<template>
  <div class="bgtype minwidth mw100" style="z-index: 99">
    <div class="flex flex-bt tabHeight">
      <div class="h100 mlogo"
        style="padding-left: 5rem; display: flex; align-items: center; justify-content: flex-start;">
        <img :src="logo" alt="" class="logoheight" @click="main" />
      </div>
      <div class="h100 flex h50 paddingrig disnone">
        <div v-for="(item, index) in displayTabList" :key="item.name" class="tab margincentY" @click="skip(item)">
          <el-button class="tabFont" type="text">{{ item.name }}</el-button>
        </div>
      </div>
      <div class="h100 disnone2">
        <el-button class="h100 tabListBut" @click="showList = true" type="text" icon="el-icon-s-operation"></el-button>
      </div>
    </div>
    <div v-if="showList" style="
        background-color: #fff;
        width: 70%;
        height: 100vh;
        position: fixed;
        top: 0;
        z-index: 10;
      " class="disnone2">
      <div>
        <el-button style="margin-top: 1vh; margin-left: 2vw;" @click="showList = false" circle size="medium"
          icon="el-icon-close"></el-button>
      </div>
      <div v-for="(item, index) in displayTabList" :key="item.name" style="width: 80%; margin: 0 auto; text-align: center"
        @click="skip(item)">
        <el-button class="tabFont" type="text">{{ item.name }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { isLoggedIn, logout } from '../utils/auth'

export default {
  data() {
    return {
      logo: 'https://java-1316167083.cos.ap-shanghai.myqcloud.com/java-1316167083/7f28b1c390c16dc2d252373cbabb468ca5bbb9dd7a903adc493c3c50541169f3.webp',

      tabNow: 0,
      tabList: [
        { name: "首页", url: "/" },
        { name: "关于我们", url: "/partner" },
        { name: "行业案例", url: "/trends" },
        { name: "联系我们", url: "/join" },
        { name: "行业资讯", url: "/news" },
      ],

      loggedIn: false,
      isMobile: false,
      showList: false,
    };
  },

  computed: {
    displayTabList() {
      const authItem = this.loggedIn
        ? { name: '退出登录', action: 'logout' }
        : { name: '登录', url: '/login' }
      return [...this.tabList, authItem]
    },
  },

  created() {
    this.refreshLoginState()
  },

  watch: {
    $route() {
      this.refreshLoginState()
    },
  },

  methods: {
    refreshLoginState() {
      this.loggedIn = isLoggedIn()
    },
    main() {
      this.$router.push("/");
    },
    skip(item) {
      this.showList = false
      if (item.action === 'logout') {
        logout()
        this.loggedIn = false
        this.$message.success('已退出登录')
        if (this.$route.path === '/login' || this.$route.path === '/register') {
          return
        }
        this.$router.push('/')
        return
      }
      this.$router.push(item.url);
    },
  },
};
</script>

<style scoped>
.bgtype {
  /* background-color: transparent; */
  background-color: #444;
  width: 100%;
  height: auto;
  z-index: 99;
  margin: 0 auto;
}

.flex {
  display: flex;
  align-content: center;
  justify-content: center;
}

.flex-bt {
  justify-content: space-between;
}

.h100 {
  height: 100%;
}

.w100 {
  width: 100%;
}

.minwidth {
  min-width: 1000px;
}

.logowidth {
  width: 280px;
}

.logoheight {
  height: 30%;
  /* margin-top: 1rem; */
}

.margincentY {
  margin: auto 0;
}

.paddingrig {
  padding-right: 10%;
}

.tab {
  margin-left: 30px;
}

.tabFont {
  font-weight: bolder;
  font-size: 18px;
  line-height: 50px;
  /* color: rgb(233 192 131); */
  /* color: #333 !important; */
  color: #fff !important;
  background-color: transparent;
  border-style: none;
}

.tabHeight {
  height: 100px;
}

.disnone2 {
  display: none;
}

@media screen and (max-width: 750px) {
  .minwidth {
    min-width: 0px;
  }

  .flexnone {
    display: block;
  }

  .mw100 {
    width: 100vw;
  }

  .tab {
    margin-left: 0px;
  }

  .bgtype {
    background-color: transparent;
    width: 80%;
    height: auto;
    z-index: 99;
    margin: 0 auto;
  }

  .tabFont {
    font-weight: bold;
    font-size: 16px;
    line-height: 50px;
    color: #000 !important;
    background-color: transparent;
    border-style: none;
  }

  .tabHeight {
    height: 8vh;
  }

  .mlogo {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .h50 {
    height: 50px;
  }

  .paddingrig {
    padding-right: 0;
  }

  .disnone {
    display: none;
  }

  .disnone2 {
    display: block;
  }

  .tabListBut,
  .tabListBut:hover {
    width: 10vw;
    margin-right: 2vw;
    font-size: 8vw;
    color: rgb(233 192 131);
  }

}
</style>
